<template>
  <div class="upload-group" :class="{'visible': visible}">
    <div class="bg-mask" @touchmove.stop.prevent></div>
    <transition name="fade">
      <div class="uploadCont" v-show="visible">
        <div class="upload-banner">
            <span>{{popItem.title}}</span>
            <img-v3 :src="require('../../../images/close.png')" @click="closeUploadImg"/>
        </div>
        <div class="upload-eg">
          <div class="img-wrap">
            <img-v3 :src="popItem.exam_pic_url[0]" alt="" class="exam-pic" />
          </div>
          <div class="upload-eg-text">
            <p class="content-title">{{popItem.pic_desc.title}}</p>
            <p class="content-p" v-for="(t,idx) in popItem.pic_desc.content" :key="idx" v-html="t"></p>
          </div>
        </div>
        <div class="btn-wrap" v-if="!isSuccess">
          <div class="upload-btn" :style="btnStyle">
            <template v-if="inApp">
              <input type="button" @click="selectImg" />
              {{btnInfo.title}}
            </template>
            <template v-else>
              <input :id="`photo-${idx}`" type="file" accept="image/*" />
              {{btnInfo.title}}
            </template>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { imgCompress } from "../../../tools/utils";
import { post } from "../../../tools/request";
import { showLoadingToast, showAlertDialog } from "../../../tools/Tip";

export default {
  props: ["formItem", "visible", "idx"],
  data(){
    return {
      uploadImgSrc: '',
      uploadStart: 0,
      b2md5: null,
      store_result: null,
    }
  },
  computed: {
    ...mapState(["_ticket", "_uuid"]),
    inApp() {
      return !!Fusion.pickImage;
    },
    // idx() {
    //   return this.formItem.idx;
    // },
    popItem() {
      return this.formItem.upload_pop || this.formItem;
    },
    isIng() {
      return this.formItem.field_status == 3;
    },
    isSuccess() {
      return this.formItem.field_status == 4;
    },
    isFailed() {
      return this.formItem.field_status == 5;
    },
    btnInfo() {
      return this.isIng ? (this.popItem.button_color || {}).is_check || {} : (this.popItem.button_color || {}).un_check || {};
    },
    btnStyle() {
      return {
        color: this.btnInfo.text_color,
        background: this.btnInfo.background_color
      }
    },
    document_enum() {
      return this.formItem.document_enum || "";
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initOutUpload();
    });

  },
  methods: {
    closeUploadImg(){
      this.$emit('closeUploadImg');
    },
    initOutUpload() {
      //端外使用input上传
      if (!this.inApp) {
        const photoBtn = document.getElementById(`photo-${this.idx}`);
        imgCompress(photoBtn, this.handleAfterChoose, this.handleImageError);
        // photoBtn.onclick = () => {
        //   Omega.trackEvent("gd_oasisUploadCertificates_confirm_ck", "", {
        //     type: this.popItem.key
        //   });
        // };
      }
    },
    selectImg() {
      Fusion.pickImage(
        {
          width: '1500',
          height: '1500'
        },
        ret => this.handleAfterChoose(ret)
      );

    },
    handleAfterChoose(ret) {
      if (ret.errorCode != 104) {
        return;
      }
      let imgSrc = ret.imageBase64String;
      if (this.inApp) {
        imgSrc = "data:image/jpeg" + ";base64," + ret.imageBase64String;
      }
      this.uploadImgSrc = imgSrc;
      try {
        if (window.localStorage) {
          this.b2md5 = md5(this.uploadImgSrc);
          this.store_result = window.localStorage.getItem(this.b2md5);

        }
      } catch (e) {}

      //通知父级组件重新渲染
      this.$emit("btn-update");
      // 上传图片
      this.uploadImg();

    },
    handleImageError() {
      showAlertDialog(this, this.$t("图片尺寸过大"));
    },
    uploadImg() {
      this.uploadStart = +new Date();
      showLoadingToast(this);
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      let success = data => {
        this.toast.hide();
        if (data.low_quality_res && data.low_quality_res === 1) {
          showAlertDialog(this, data.low_quality_des);
          return false;
        }
        this.formItem.show_value = [data.img_id];
        //通知父级组件重新渲染
        // emitFormUpdate(this, this.idx, { ...this.formItem, uploadImgSrc: this.uploadImgSrc});
        this.$emit('pop-upload-cb', this.uploadImgSrc);
        // this.$emit('closeUploadImg');
        try {
          if (this.b2md5 && !this.store_result) {
            //后半段判断，防止多次选择同一图片后，重复的set操作
            window.localStorage.setItem(this.b2md5, data.img_id);
          }
        } catch (e) {}
      };
      if (this.store_result) {
        success({ img_id: this.store_result });
        // Omega.trackEvent("hit_img_cache_upload", "", {
        //   duid: this._uuid,
        //   app_upload: this.inApp
        // });
        return;
      }
      up.append("__x_img", this.uploadImgSrc);
      up.append("type", this.formItem.key);
      up.append("document_enum", this.document_enum);

      post(process.env.UPLOAD_IMG, up)
        .then(success)
        .catch(this.httpError);
    },
     httpError(res) {
      this.toast.hide();
      showAlertDialog(this, res.errmsg);
    }
  },
}

</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transform: translateY(0%);
}
.fade-enter,
.fade-leave-to,
.fade-leave-active {
  transform: translateY(100%);
}
.upload-group {
    // display: none;
    position: fixed;
    z-index: 6;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .bg-mask {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(33,42,52,0.40);
      z-index: 10;
    }


}

// .upload-group.visible {
//     display: block;
// }

.uploadCont {
  position: absolute;
  bottom: 0;
  z-index: 11;
  background: white;
  width: 100%;
  height: 85%;
  bottom: 0;
  border-radius: .12rem .12rem 0 0;
  transition: all 0.3s ease;
  .upload-banner {
    position: relative;
    padding: 0.32rem;
    height: 1.16rem;
    box-sizing: border-box;
    font-size: 0.4rem;
    font-weight: 500;
    > span {
      vertical-align: middle;
    }
    > img {
      position: absolute;
      right: 0.32rem;
      top: 50%;
      margin-top: -0.14rem;
      width: 0.28rem;
      height: 0.28rem;
    }
  }
  .upload-eg {
    box-sizing: border-box;
    padding: 0.2rem 0.32rem 3.2rem;
    height: 100%;
    overflow-y: scroll;
  }
  .img-wrap {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 3.6rem;
    margin-bottom: 0.32rem;
    background: rgba(145,160,180,0.15);
    border-radius: 0.04rem;
  }
  .exam-pic {
    // width: 4.08rem;
    max-width: 4.53rem;
    height: 3.2rem;
  }
  .upload-eg-text {
    line-height: 0.48rem;
    color: #666666;
    font-size: 0.32rem;
    word-break: break-word;
  }
  .btn-wrap {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    padding: 0.32rem;
    box-sizing: border-box;
    background: #ffffff;
    .upload-btn {
      position: relative;
      width: 100%;
      height: 1.08rem;
      line-height: 1.08rem;
      text-align: center;
      font-size: 0.36rem;
      font-weight: 500;
      border-radius: 0.04rem;
      box-shadow: 0 -20px 20px 0 rgba(0,0,0,0.04);
      background: #FFDC14;
      color: #333333;
      > input {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        opacity: 0;
      }
    }
  }
}
</style>
